export default [
  {
    path: 'store',
    name: 'store.index',
    meta: {
      title: 'Loja',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "store" */ '../views/store/Show.vue')
  },
  {
    path: 'store/create',
    name: 'store.create',
    meta: {
      title: 'Criar nova Loja',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "store" */ '../views/store/Create.vue')
  },
  {
    path: 'product',
    name: 'store.product.index',
    meta: {
      title: 'Produtos',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "store" */ '../views/store/product/Index.vue')
  },
  {
    path: 'product/create',
    name: 'store.product.create',
    meta: {
      title: 'Adicionando novo produto',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "store" */ '../views/store/product/Create.vue')
  },
  {
    path: 'product/:product',
    name: 'store.product.show',
    meta: {
      title: 'Visualizando',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "store" */ '../views/store/product/Create.vue')
  },
  {
    path: 'category',
    name: 'store.category.index',
    meta: {
      title: 'Categorias',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "store" */ '../views/store/category/Index.vue')
  },
  {
    path: 'category/create',
    name: 'store.category.create',
    meta: {
      title: 'Criar uma nova categoria',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "store" */ '../views/store/category/Create.vue')
  },
  {
    path: 'category/:category',
    name: 'store.category.show',
    meta: {
      title: 'Editar categoria',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "store" */ '../views/store/category/Create.vue')
  }
]
